import { BaseViewModel } from "@iot-platform/core";
import {
    SpatialLevel,
    SpatialLevels,
} from "@station/domain/models/spatial-level.model";
import type { Station } from "@station/domain/models/station.model";
import { injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class StationMapViewmodel extends BaseViewModel {
    @observable
    spatialLevels: SpatialLevels = SpatialLevels.empty();

    @observable
    markers: Readonly<Station>[] = [];

    constructor() {
        super();
        makeObservable(this);
    }

    override didMount(): void {
        this.initViewData();
    }

    @action
    setSpatialLevels(spatialLevels: SpatialLevels): void {
        this.spatialLevels = spatialLevels;
        this.initViewData();
    }

    private initViewData(): void {
        this.initMarkers();
    }

    @action
    initMarkers(stations?: readonly Readonly<Station>[]): void {
        runInAction(() => {
            const validMarkers: Readonly<Station>[] = [];

            if (stations) {
                stations.forEach((station) => {
                    if (station.latitude && station.longitude) {
                        validMarkers.push(station);
                    }
                });
            } else {
                const traverseLevels = (
                    level: Readonly<SpatialLevel>,
                ): void => {
                    level.stations.forEach((station) => {
                        if (station.latitude && station.longitude) {
                            validMarkers.push(station);
                        }
                    });

                    level.children?.forEach((child) => {
                        traverseLevels(child);
                    });
                };

                this.spatialLevels.spatialLevels.forEach((level) => {
                    traverseLevels(level);
                });
            }

            this.markers = validMarkers;
        });
    }
}
